"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.OrderField13 = exports.OrderField12 = exports.OrderField11 = exports.OrderField10 = exports.OrderField9 = exports.OrderField8 = exports.OrderField7 = exports.OrderField6 = exports.OrderField5 = exports.OrderField4 = exports.OrderField3 = exports.OrderField2 = exports.OrderField = exports.UserStatus = exports.TraitCode = exports.SortOrderDirection = exports.ServiceErrorCode = exports.ResourceType = exports.LoginResultCode = exports.LicenseType = exports.KeyRemapReason = exports.JobFunction = exports.IdentityProviderType = exports.GrantType = exports.ExternalLicense = exports.DraftAccountStatus = exports.DisabledReason = exports.CrmLinkedStatus = exports.ConfigurationGroupFilter = exports.ConfigurationGroup = exports.ActionType = exports.AccountType = exports.AccountStatus = exports.Client = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
const axios_1 = __importDefault(require("axios"));
class Client {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance || axios_1.default.create();
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "http://system.api.local.oncmg.io/";
    }
    /**
     * Regenerates the api client's secret for the specified account.
     * @return OK
     */
    apiClient_RegenerateApiClientSecret(accountSubdomain, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiClient/secret";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiClient_RegenerateApiClientSecret(_response);
        });
    }
    processApiClient_RegenerateApiClientSecret(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Gets the api client for the specified account.
     * @return OK
     */
    apiClient_GetApiClient(accountSubdomain, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiClient";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiClient_GetApiClient(_response);
        });
    }
    processApiClient_GetApiClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates an api client for the specified account. This client (clientId/clientSecret) can be used with the Resource Owner Password Grant to acquire an access token.
     * @param body (optional)
     * @return OK
     */
    apiClient_CreateApiClient(accountSubdomain, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiClient";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiClient_CreateApiClient(_response);
        });
    }
    processApiClient_CreateApiClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update the api client for the specified account.
     * @param body (optional)
     * @return OK
     */
    apiClient_UpdateApiClient(accountSubdomain, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiClient";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiClient_UpdateApiClient(_response);
        });
    }
    processApiClient_UpdateApiClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an API key by the specified id.
     * @param id The id of the key to delete.
     * @return No Content
     */
    apiKeysManagement_DeleteApiKey(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiKeys/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeysManagement_DeleteApiKey(_response);
        });
    }
    processApiKeysManagement_DeleteApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get an API key by the specified Id.
     * @return OK
     */
    apiKeysManagement_GetApiKey(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiKeys/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeysManagement_GetApiKey(_response);
        });
    }
    processApiKeysManagement_GetApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Regenerate a new key using the same permissions as the current key.
     * @return OK
     */
    apiKeysManagement_RegenerateApiKey(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiKeys/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeysManagement_RegenerateApiKey(_response);
        });
    }
    processApiKeysManagement_RegenerateApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of API keys using the specified search criteria.
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    apiKeysManagement_QueryApiKeys(accountSubdomain, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiKeys?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeysManagement_QueryApiKeys(_response);
        });
    }
    processApiKeysManagement_QueryApiKeys(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Create an new API key. The API key contains an access token that can be used to make calls to
    datalab/xecution APIs in a non-interactive mode (i.e machine to machine communication, without a human in the loop).
     * @param body (optional)
     * @return Created
     */
    apiKeysManagement_CreateApiKey(accountSubdomain, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/apiKeys";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeysManagement_CreateApiKey(_response);
        });
    }
    processApiKeysManagement_CreateApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an account configuration value.
     * @return No Content
     */
    accountConfigurationsManagement_DeleteAccountConfiguration(accountSubdomain, key, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/configurations/{key}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountConfigurationsManagement_DeleteAccountConfiguration(_response);
        });
    }
    processAccountConfigurationsManagement_DeleteAccountConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get account configuration by the specified key.
     * @return OK
     */
    accountConfigurationsManagement_GetAccountConfigurationByKey(accountSubdomain, key, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/configurations/{key}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountConfigurationsManagement_GetAccountConfigurationByKey(_response);
        });
    }
    processAccountConfigurationsManagement_GetAccountConfigurationByKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Sets a value for one specific configuration on the given account
     * @param body (optional)
     * @return OK
     */
    accountConfigurationsManagement_CreateAccountConfiguration(accountSubdomain, key, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/configurations/{key}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountConfigurationsManagement_CreateAccountConfiguration(_response);
        });
    }
    processAccountConfigurationsManagement_CreateAccountConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an account configuration value.
     * @param body (optional)
     * @return OK
     */
    accountConfigurationsManagement_UpdateAccountConfiguration(accountSubdomain, key, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/configurations/{key}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountConfigurationsManagement_UpdateAccountConfiguration(_response);
        });
    }
    processAccountConfigurationsManagement_UpdateAccountConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of configurations using the specified search criteria.
     * @param configurationGroup (optional)
     * @param searchText (optional)
     * @param orderField (optional)
     * @param orderDirection (optional)
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    accountConfigurationsManagement_QueryAccountConfigurations(accountSubdomain, configurationGroup, searchText, orderField, orderDirection, page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/configurations?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (configurationGroup !== undefined && configurationGroup !== null)
            url_ += "configurationGroup=" + encodeURIComponent("" + configurationGroup) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountConfigurationsManagement_QueryAccountConfigurations(_response);
        });
    }
    processAccountConfigurationsManagement_QueryAccountConfigurations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Query Events for a specific Account ID from the EventHub database
     * @param createdAfter (optional)
     * @param afterEventId (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param perPage (optional)
     * @return OK
     */
    eventHubEventsAdmin_QueryEventsForAccount(createdAfter, afterEventId, page, includeTotals, orderDirection, perPage, accountSubdomain, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/eventHub/events?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (createdAfter !== undefined && createdAfter !== null)
            url_ += "createdAfter=" + encodeURIComponent("" + createdAfter) + "&";
        if (afterEventId !== undefined && afterEventId !== null)
            url_ += "afterEventId=" + encodeURIComponent("" + afterEventId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEventHubEventsAdmin_QueryEventsForAccount(_response);
        });
    }
    processEventHubEventsAdmin_QueryEventsForAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves permissions defined in the system for the given account.
     * @return OK
     */
    permissions_GetAccountPermissions(accountSubdomain, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/permissions";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPermissions_GetAccountPermissions(_response);
        });
    }
    processPermissions_GetAccountPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get users assigned to the role with the specified role id.
     * @param userStatus (optional)
     * @param accountConfirmed (optional)
     * @param jobFunction (optional)
     * @param employeeKey (optional)
     * @param roleId (optional)
     * @param modifiedAfter (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    rolesManagement_GetUsersByRoleId(accountSubdomain, id, userStatus, accountConfirmed, jobFunction, employeeKey, roleId, modifiedAfter, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/roles/{id}/users?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userStatus !== undefined && userStatus !== null)
            url_ += "userStatus=" + encodeURIComponent("" + userStatus) + "&";
        if (accountConfirmed !== undefined && accountConfirmed !== null)
            url_ += "accountConfirmed=" + encodeURIComponent("" + accountConfirmed) + "&";
        if (jobFunction !== undefined && jobFunction !== null)
            url_ += "jobFunction=" + encodeURIComponent("" + jobFunction) + "&";
        if (employeeKey !== undefined && employeeKey !== null)
            url_ += "employeeKey=" + encodeURIComponent("" + employeeKey) + "&";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (modifiedAfter !== undefined && modifiedAfter !== null)
            url_ += "modifiedAfter=" + encodeURIComponent("" + modifiedAfter) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRolesManagement_GetUsersByRoleId(_response);
        });
    }
    processRolesManagement_GetUsersByRoleId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a role by the specified id.
     * @param accountSubdomain The subdomain of the account to send the request to.
     * @param id The id of the role to delete.
     * @return No Content
     */
    rolesManagement_DeleteRole(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/roles/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRolesManagement_DeleteRole(_response);
        });
    }
    processRolesManagement_DeleteRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get role by the specified id.
     * @param accountSubdomain The subdomain of the account to send the request to.
     * @param id The id of the role to retrieve.
     * @return OK
     */
    rolesManagement_GetRoleById(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/roles/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRolesManagement_GetRoleById(_response);
        });
    }
    processRolesManagement_GetRoleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a role with the object's properties received in the request's body.
     * @param accountSubdomain The subdomain of the account to send the request to.
     * @param id The id of the user to update.
     * @param body (optional) The definition of the role to update.
     * @return OK
     */
    rolesManagement_UpdateRole(accountSubdomain, id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/roles/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRolesManagement_UpdateRole(_response);
        });
    }
    processRolesManagement_UpdateRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of roles using the specified search criteria.
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    rolesManagement_QueryRoles(accountSubdomain, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/roles?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRolesManagement_QueryRoles(_response);
        });
    }
    processRolesManagement_QueryRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new role according to the JSON object received in body.
     * @param accountSubdomain The subdomain of the account to send the request to.
     * @param body (optional) The definition of the role to create.
     * @return Created
     */
    rolesManagement_CreateRole(accountSubdomain, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/roles";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRolesManagement_CreateRole(_response);
        });
    }
    processRolesManagement_CreateRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new test user.
     * @param body (optional) The user object to create.
     * @return Created
     */
    userManagement_CreateTestUser(accountSubdomain, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/testUsers";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_CreateTestUser(_response);
        });
    }
    processUserManagement_CreateTestUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates user email to the specified email.
     * @param id The id of the user to update.
     * @param body (optional) The new email address.
     * @return No Content
     */
    userManagement_UpdateUserEmail(accountSubdomain, id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/email";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_UpdateUserEmail(_response);
        });
    }
    processUserManagement_UpdateUserEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Sends (or re-sends) an invitation to the user to set a password and activate their account.
    Note, if the user account is already activated, the invite will not be resent.
     * @param id The id of the user to send welcome email to.
     * @return No Content
     */
    userManagement_SendNewUserInvite(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/invites";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_SendNewUserInvite(_response);
        });
    }
    processUserManagement_SendNewUserInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Sends a reset password email to the user.
     * @param id The id of the user to send welcome email to.
     * @return No Content
     */
    userManagement_SendResetPasswordEmail(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/resetPasswordRequests";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_SendResetPasswordEmail(_response);
        });
    }
    processUserManagement_SendResetPasswordEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get roles assigned to the user with the specified id.
     * @param id The id of the user.
     * @return OK
     */
    userManagement_GetUserRoles(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/roles";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_GetUserRoles(_response);
        });
    }
    processUserManagement_GetUserRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Assigns the specified roles to the user with the specified id.
     * @param id The id of the user to assign roles to.
     * @param body (optional) The list of roles to assign to the user.
     * @return OK
     */
    userManagement_UpdateUserRoles(accountSubdomain, id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/roles";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_UpdateUserRoles(_response);
        });
    }
    processUserManagement_UpdateUserRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Change user status to the specified status
     * @param id The id of the user to update.
     * @param body (optional) The status to set.
     * @return No Content
     */
    userManagement_SetUserStatus(accountSubdomain, id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/status";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_SetUserStatus(_response);
        });
    }
    processUserManagement_SetUserStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Unlocks user account if the user has been locked out due to too many failed login attempts.
     * @param id The id of the user to unlock.
     * @return No Content
     */
    userManagement_UnlockUserAccount(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}/unlock";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_UnlockUserAccount(_response);
        });
    }
    processUserManagement_UnlockUserAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get user by the specified id.
     * @param accountSubdomain The subdomain of the account to send the request to.
     * @param id The id of the user to retrieve.
     * @return OK
     */
    userManagement_GetUserById(accountSubdomain, id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_GetUserById(_response);
        });
    }
    processUserManagement_GetUserById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Partially updates a user with the object's properties received in the request's body. Note, only properties that are set on will be update.
     * @param id The id of the user to update.
     * @param body (optional) The user properties.
     * @return OK
     */
    userManagement_PatchUser(accountSubdomain, id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_PatchUser(_response);
        });
    }
    processUserManagement_PatchUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a user with the object's properties received in the request's body.
     * @param id The id of the user to update.
     * @param body (optional) The user object to update.
     * @return OK
     */
    userManagement_UpdateUser(accountSubdomain, id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/{id}";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_UpdateUser(_response);
        });
    }
    processUserManagement_UpdateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Export the current users to an Excel file
     * @param accountSubdomain The subdomain of the account to send the request to
     * @return Excel file with the data of the users for the given account
     */
    userManagement_ExportUsers(accountSubdomain, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users/export";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_ExportUsers(_response);
        });
    }
    processUserManagement_ExportUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of users using the specified search criteria.
     * @param userStatus (optional)
     * @param accountConfirmed (optional)
     * @param jobFunction (optional)
     * @param employeeKey (optional)
     * @param roleId (optional)
     * @param modifiedAfter (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    userManagement_QueryUsers(accountSubdomain, userStatus, accountConfirmed, jobFunction, employeeKey, roleId, modifiedAfter, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (userStatus !== undefined && userStatus !== null)
            url_ += "userStatus=" + encodeURIComponent("" + userStatus) + "&";
        if (accountConfirmed !== undefined && accountConfirmed !== null)
            url_ += "accountConfirmed=" + encodeURIComponent("" + accountConfirmed) + "&";
        if (jobFunction !== undefined && jobFunction !== null)
            url_ += "jobFunction=" + encodeURIComponent("" + jobFunction) + "&";
        if (employeeKey !== undefined && employeeKey !== null)
            url_ += "employeeKey=" + encodeURIComponent("" + employeeKey) + "&";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (modifiedAfter !== undefined && modifiedAfter !== null)
            url_ += "modifiedAfter=" + encodeURIComponent("" + modifiedAfter) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_QueryUsers(_response);
        });
    }
    processUserManagement_QueryUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new user according to the JSON object received in body.
     * @param sendInvite (optional) Indicates whether to send a welcome email to the user.
     * @param body (optional) The user object to create.
     * @return Created
     */
    userManagement_CreateUser(accountSubdomain, sendInvite, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/{accountSubdomain}/users?";
        if (accountSubdomain === undefined || accountSubdomain === null)
            throw new Error("The parameter 'accountSubdomain' must be defined.");
        url_ = url_.replace("{accountSubdomain}", encodeURIComponent("" + accountSubdomain));
        if (sendInvite === null)
            throw new Error("The parameter 'sendInvite' cannot be null.");
        else if (sendInvite !== undefined)
            url_ += "sendInvite=" + encodeURIComponent("" + sendInvite) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_CreateUser(_response);
        });
    }
    processUserManagement_CreateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Assigns a external license to the specified account.
     * @param id The id of the account to update.
     * @param body (optional) The external license for the account.
     * @return OK
     */
    accountManagement_AssignExternalLicense(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/externalLicense";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_AssignExternalLicense(_response);
        });
    }
    processAccountManagement_AssignExternalLicense(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Remove a external license from the specified account.
     * @param id The id of the account to update.
     * @param body (optional) The external license that will be removed from the account.
     * @return No Content
     */
    accountManagement_RemoveExternalLicense(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/externalLicenses";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_RemoveExternalLicense(_response);
        });
    }
    processAccountManagement_RemoveExternalLicense(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Assigns a set external licenses to the specified account.
     * @param id The id of the account to update.
     * @param body (optional) The external licenses list for the account.
     * @return OK
     */
    accountManagement_AssignExternalLicenses(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/externalLicenses";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_AssignExternalLicenses(_response);
        });
    }
    processAccountManagement_AssignExternalLicenses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get identity provider configuration for the specified provider type.
     * @param id The id of the account to update.
     * @param providerType azure active directory provider properties to update.
     * @return OK
     */
    accountManagement_GetIdentityProvider(id, providerType, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/{providerType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (providerType === undefined || providerType === null)
            throw new Error("The parameter 'providerType' must be defined.");
        url_ = url_.replace("{providerType}", encodeURIComponent("" + providerType));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetIdentityProvider(_response);
        });
    }
    processAccountManagement_GetIdentityProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get Azure AD OpenId Connect metadata.
     * @return OK
     */
    accountManagement_GetAzureAdOpenIdMetadata(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/azureAdOpenId/metadata";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetAzureAdOpenIdMetadata(_response);
        });
    }
    processAccountManagement_GetAzureAdOpenIdMetadata(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates azure active directory identity provider configurations
     * @param id The id of the account to update.
     * @param body (optional) azure active directory provider properties to update.
     * @return OK
     */
    accountManagement_UpdateAzureAdConfiguration(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/azureAdOpenId";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdateAzureAdConfiguration(_response);
        });
    }
    processAccountManagement_UpdateAzureAdConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Gets the genetic OpenId Connect provider metadata.
     * @return OK
     */
    accountManagement_GetOpenIdConnectMetadata(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/openIdConnect/metadata";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetOpenIdConnectMetadata(_response);
        });
    }
    processAccountManagement_GetOpenIdConnectMetadata(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the generic OpenID Connect provider configuration.
     * @param id The id of the account to update.
     * @param body (optional) OpenID Connect provider configuration to update.
     * @return OK
     */
    accountManagement_UpdateOpenIdConnectConfiguration(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/openIdConnect";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdateOpenIdConnectConfiguration(_response);
        });
    }
    processAccountManagement_UpdateOpenIdConnectConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get SAML Service Provider metadata.
     * @return OK
     */
    accountManagement_GetSamlMetadata(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/saml2p/metadata";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetSamlMetadata(_response);
        });
    }
    processAccountManagement_GetSamlMetadata(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates SAML2p identity provider configurations.
     * @param id The id of the account to update.
     * @param body (optional) SAML provider properties to update.
     * @return OK
     */
    accountManagement_UpdateSamlConfiguration(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders/saml2p";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdateSamlConfiguration(_response);
        });
    }
    processAccountManagement_UpdateSamlConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get list of identity providers for the specified account.
     * @return OK
     */
    accountManagement_GetIdentityProviders(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/identityProviders";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetIdentityProviders(_response);
        });
    }
    processAccountManagement_GetIdentityProviders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get account's password policy.
     * @return OK
     */
    accountManagement_GetPasswordPolicy(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/passwordPolicy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetPasswordPolicy(_response);
        });
    }
    processAccountManagement_GetPasswordPolicy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update account's password policy.
     * @param id The id of the account to update.
     * @param body (optional) Password policy properties to update.
     * @return OK
     */
    accountManagement_UpdatePasswordPolicy(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/passwordPolicy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdatePasswordPolicy(_response);
        });
    }
    processAccountManagement_UpdatePasswordPolicy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Re-trigger tenant provisioning for the specified account. It will automatically resume/retry provisioning for any failed service
     * @return No Content
     */
    accountManagement_RetryAccountProvisioningForAccount(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/provisioning/retry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_RetryAccountProvisioningForAccount(_response);
        });
    }
    processAccountManagement_RetryAccountProvisioningForAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get the database provisioning status for one specific account
     * @return OK
     */
    accountManagement_GetAccountProvisioningStatus(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/provisioning/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetAccountProvisioningStatus(_response);
        });
    }
    processAccountManagement_GetAccountProvisioningStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Change account status to the specified status
     * @param id The id of the account to update.
     * @param body (optional) The status to set.
     * @return No Content
     */
    accountManagement_SetAccountStatus(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_SetAccountStatus(_response);
        });
    }
    processAccountManagement_SetAccountStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Remove a trait from the specified account.
     * @param id The id of the account to update.
     * @param trait The trait that will be removed from the account.
     * @return No Content
     */
    accountManagement_RemoveTrait(id, trait, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/traits/{trait}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (trait === undefined || trait === null)
            throw new Error("The parameter 'trait' must be defined.");
        url_ = url_.replace("{trait}", encodeURIComponent("" + trait));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_RemoveTrait(_response);
        });
    }
    processAccountManagement_RemoveTrait(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Assigns a trait to the specified account.
     * @param id The id of the account to update.
     * @param body (optional) The trait assign to the account.
     * @return OK
     */
    accountManagement_AssignTrait(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/traits";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_AssignTrait(_response);
        });
    }
    processAccountManagement_AssignTrait(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Assigns a set traits to the specified account.
     * @param id The id of the account to update.
     * @param body (optional) The traits list for the account.
     * @return OK
     */
    accountManagement_AssignTraits(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}/traits";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_AssignTraits(_response);
        });
    }
    processAccountManagement_AssignTraits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get account by the specified id.
     * @param id The id of the account to retrieve.
     * @return OK
     */
    accountManagement_GetAccountById(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetAccountById(_response);
        });
    }
    processAccountManagement_GetAccountById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Partially updates an account with the object's properties received in the request's body. Note, only properties that are set on will be updated.
     * @param id The id of the account to update.
     * @param body (optional) Account properties to update.
     * @return OK
     */
    accountManagement_PatchAccount(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_PatchAccount(_response);
        });
    }
    processAccountManagement_PatchAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an account. The existing record will be override with the object in the request body.
     * @param id The id of the account to update.
     * @param body (optional) Account properties to update.
     * @return OK
     */
    accountManagement_UpdateAccount(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdateAccount(_response);
        });
    }
    processAccountManagement_UpdateAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get account by the specified subdomain.
     * @param subdomain The subdomain of the account to retrieve.
     * @return OK
     */
    accountManagement_GetAccountBySubdomain(subdomain, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/{subdomain}";
        if (subdomain === undefined || subdomain === null)
            throw new Error("The parameter 'subdomain' must be defined.");
        url_ = url_.replace("{subdomain}", encodeURIComponent("" + subdomain));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_GetAccountBySubdomain(_response);
        });
    }
    processAccountManagement_GetAccountBySubdomain(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update the Linked CMG Entity Keys for one specific account.
     * @return No Content
     */
    accountManagement_UpdateLinkedCmgEntityKeysForAccount(accountId, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/linkedCmgEntityKeys/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdateLinkedCmgEntityKeysForAccount(_response);
        });
    }
    processAccountManagement_UpdateLinkedCmgEntityKeysForAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the Linked CMG Entity Keys for all accounts at once.
     * @return No Content
     */
    accountManagement_UpdateLinkedCmgEntityKeysForAllAccounts(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/linkedCmgEntityKeys";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_UpdateLinkedCmgEntityKeysForAllAccounts(_response);
        });
    }
    processAccountManagement_UpdateLinkedCmgEntityKeysForAllAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Run the remapping operation for all accounts described in payload
     * @param body (optional)
     * @return OK
     */
    accountManagement_RemapKeys(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts/remap";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_RemapKeys(_response);
        });
    }
    processAccountManagement_RemapKeys(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of account using the specified search criteria.
     * @param accountType (optional)
     * @param licenseType (optional)
     * @param status (optional)
     * @param traits (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    accountManagement_QueryAccounts(accountType, licenseType, status, traits, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts?";
        if (accountType !== undefined && accountType !== null)
            url_ += "accountType=" + encodeURIComponent("" + accountType) + "&";
        if (licenseType !== undefined && licenseType !== null)
            url_ += "licenseType=" + encodeURIComponent("" + licenseType) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (traits !== undefined && traits !== null)
            traits && traits.forEach(item => { url_ += "traits=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_QueryAccounts(_response);
        });
    }
    processAccountManagement_QueryAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new account according to the JSON object received in body.
     * @param body (optional) The account to create.
     * @return Created
     */
    accountManagement_CreateAccount(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/accounts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountManagement_CreateAccount(_response);
        });
    }
    processAccountManagement_CreateAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get configuration by the specified key.
     * @return OK
     */
    configurationsManagement_GetConfigurationByKey(key, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/configurations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConfigurationsManagement_GetConfigurationByKey(_response);
        });
    }
    processConfigurationsManagement_GetConfigurationByKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a configuration value.
     * @param body (optional)
     * @return OK
     */
    configurationsManagement_UpdateConfiguration(key, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/configurations/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConfigurationsManagement_UpdateConfiguration(_response);
        });
    }
    processConfigurationsManagement_UpdateConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of the available configuration groups
     * @return OK
     */
    configurationsManagement_QueryConfigurationGroups(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/configurations/groups";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConfigurationsManagement_QueryConfigurationGroups(_response);
        });
    }
    processConfigurationsManagement_QueryConfigurationGroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of configurations using the specified search criteria.
     * @param configurationGroup (optional)
     * @param searchText (optional)
     * @param orderField (optional)
     * @param orderDirection (optional)
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    configurationsManagement_QueryConfigurations(configurationGroup, searchText, orderField, orderDirection, page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/configurations?";
        if (configurationGroup !== undefined && configurationGroup !== null)
            url_ += "configurationGroup=" + encodeURIComponent("" + configurationGroup) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processConfigurationsManagement_QueryConfigurations(_response);
        });
    }
    processConfigurationsManagement_QueryConfigurations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update the matching DraftAccount subdomain if the subdomain does not exist in the Accounts table
     * @param body (optional)
     * @return OK
     */
    draftAccounts_UpdateDraftAccountSubdomain(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/draftAccounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDraftAccounts_UpdateDraftAccountSubdomain(_response);
        });
    }
    processDraftAccounts_UpdateDraftAccountSubdomain(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * List DraftAccount
     * @param investorName (optional)
     * @param accountName (optional)
     * @param accountSubdomain (optional)
     * @param cmgEntityKey (optional)
     * @param invitedBy (optional)
     * @param searchText (optional)
     * @param orderField (optional)
     * @param orderDirection (optional)
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    draftAccounts_GetDraftAccounts(investorName, accountName, accountSubdomain, cmgEntityKey, invitedBy, searchText, orderField, orderDirection, page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/draftAccounts?";
        if (investorName !== undefined && investorName !== null)
            url_ += "investorName=" + encodeURIComponent("" + investorName) + "&";
        if (accountName !== undefined && accountName !== null)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
        if (accountSubdomain !== undefined && accountSubdomain !== null)
            url_ += "accountSubdomain=" + encodeURIComponent("" + accountSubdomain) + "&";
        if (cmgEntityKey !== undefined && cmgEntityKey !== null)
            url_ += "cmgEntityKey=" + encodeURIComponent("" + cmgEntityKey) + "&";
        if (invitedBy !== undefined && invitedBy !== null)
            url_ += "invitedBy=" + encodeURIComponent("" + invitedBy) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDraftAccounts_GetDraftAccounts(_response);
        });
    }
    processDraftAccounts_GetDraftAccounts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of all external licenses in the system.
     * @return OK
     */
    externalLicenses_GetAllExternalLicenses(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/externalLicenses";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processExternalLicenses_GetAllExternalLicenses(_response);
        });
    }
    processExternalLicenses_GetAllExternalLicenses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Revoke a signup token.
     * @param id The id of the signup token to revoke.
     * @return Accepted
     */
    signupToken_RevokeSignupToken(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/signupToken/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSignupToken_RevokeSignupToken(_response);
        });
    }
    processSignupToken_RevokeSignupToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get a signup token with the specified id.
     * @param id The id of the signup token to retrieve.
     * @return OK
     */
    signupToken_GetSignupTokenById(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/signupToken/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSignupToken_GetSignupTokenById(_response);
        });
    }
    processSignupToken_GetSignupTokenById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of a valid signup tokens using the specified search criteria.
     * @param tenantId (optional)
     * @param orderField (optional)
     * @param orderDirection (optional)
     * @param page (optional)
     * @param perPage (optional)
     * @param includeTotals (optional)
     * @return OK
     */
    signupToken_GetSignupTokens(tenantId, orderField, orderDirection, page, perPage, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/signupToken?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSignupToken_GetSignupTokens(_response);
        });
    }
    processSignupToken_GetSignupTokens(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new signup token for a sell side account.
     * @param body (optional) The sell side account id for generate a new token.
     * @return Created
     */
    signupToken_CreateToken(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/signupToken";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSignupToken_CreateToken(_response);
        });
    }
    processSignupToken_CreateToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new test user for the system subdomain.
     * @param body (optional) The user object to create.
     * @return Created
     */
    userManagement_CreateSystemTestUser(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/testUsers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUserManagement_CreateSystemTestUser(_response);
        });
    }
    processUserManagement_CreateSystemTestUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get a trait in the system with the specified role id.
     * @param traitCode The trait code that will be retrieved.
     * @return OK
     */
    traits_GetTraitById(traitCode, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/traits/{traitCode}";
        if (traitCode === undefined || traitCode === null)
            throw new Error("The parameter 'traitCode' must be defined.");
        url_ = url_.replace("{traitCode}", encodeURIComponent("" + traitCode));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTraits_GetTraitById(_response);
        });
    }
    processTraits_GetTraitById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of all defined traits in the system.
     * @return OK
     */
    traits_GetAllTraits(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/admin/traits";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTraits_GetAllTraits(_response);
        });
    }
    processTraits_GetAllTraits(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Query Events accessible to the current Account from EventHub
     * @param createdAfter (optional)
     * @param afterEventId (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param perPage (optional)
     * @return OK
     */
    eventHubEvents_QueryEvents(createdAfter, afterEventId, page, includeTotals, orderDirection, perPage, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/eventHub/events?";
        if (createdAfter !== undefined && createdAfter !== null)
            url_ += "createdAfter=" + encodeURIComponent("" + createdAfter) + "&";
        if (afterEventId !== undefined && afterEventId !== null)
            url_ += "afterEventId=" + encodeURIComponent("" + afterEventId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processEventHubEvents_QueryEvents(_response);
        });
    }
    processEventHubEvents_QueryEvents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param returnUrl (optional)
     * @return OK
     */
    login_GetLoginInfo(returnUrl, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/loginInfo?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogin_GetLoginInfo(_response);
        });
    }
    processLogin_GetLoginInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    login_Login(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogin_Login(_response);
        });
    }
    processLogin_Login(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an API key by the specified id.
     * @param id The id of the key to delete.
     * @return No Content
     */
    apiKeys_DeleteApiKey(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/apiKeys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeys_DeleteApiKey(_response);
        });
    }
    processApiKeys_DeleteApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get an API key by the specified Id.
     * @return OK
     */
    apiKeys_GetApiKey(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/apiKeys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeys_GetApiKey(_response);
        });
    }
    processApiKeys_GetApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Regenerate a new key using the same permissions as the current key.
     * @return OK
     */
    apiKeys_RegenerateApiKey(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/apiKeys/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeys_RegenerateApiKey(_response);
        });
    }
    processApiKeys_RegenerateApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of API keys using the specified search criteria.
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    apiKeys_QueryApiKeys(page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/apiKeys?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeys_QueryApiKeys(_response);
        });
    }
    processApiKeys_QueryApiKeys(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new API key.
     * @param body (optional)
     * @return Created
     */
    apiKeys_CreateApiKey(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/apiKeys";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processApiKeys_CreateApiKey(_response);
        });
    }
    processApiKeys_CreateApiKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get my account's configurations for the specified identity provider.
     * @param providerType azure active directory provider properties to update.
     * @return OK
     */
    accountSettings_GetIdentityProvider(providerType, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/{providerType}";
        if (providerType === undefined || providerType === null)
            throw new Error("The parameter 'providerType' must be defined.");
        url_ = url_.replace("{providerType}", encodeURIComponent("" + providerType));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_GetIdentityProvider(_response);
        });
    }
    processAccountSettings_GetIdentityProvider(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get Azure AD OpenId Connect metadata.
     * @return OK
     */
    accountSettings_GetAzureAdOpenIdMetadata(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/azureAdOpenId/metadata";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_GetAzureAdOpenIdMetadata(_response);
        });
    }
    processAccountSettings_GetAzureAdOpenIdMetadata(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates azure active directory identity provider configurations.
     * @param body (optional) azure active directory provider properties to update.
     * @return OK
     */
    accountSettings_UpdateAzureAdConfiguration(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/azureAdOpenId";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_UpdateAzureAdConfiguration(_response);
        });
    }
    processAccountSettings_UpdateAzureAdConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get the genetic OpenID Connect provider metadata.
     * @return OK
     */
    accountSettings_OpenIdConnectMetadata(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/openIdConnect/metadata";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_OpenIdConnectMetadata(_response);
        });
    }
    processAccountSettings_OpenIdConnectMetadata(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the generic OpenID Connect provider configuration.
     * @param body (optional) OpenID Connect provider configuration to update.
     * @return OK
     */
    accountSettings_UpdateOpenIdConnectConfiguration(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/openIdConnect";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_UpdateOpenIdConnectConfiguration(_response);
        });
    }
    processAccountSettings_UpdateOpenIdConnectConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get SAML Service Provider metadata.
     * @return OK
     */
    accountSettings_GetSamlMetadata(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/saml2p/metadata";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_GetSamlMetadata(_response);
        });
    }
    processAccountSettings_GetSamlMetadata(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates SAML2p identity provider configurations
     * @param body (optional) SAML provider properties to update.
     * @return OK
     */
    accountSettings_UpdateSamlConfiguration(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders/saml2p";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_UpdateSamlConfiguration(_response);
        });
    }
    processAccountSettings_UpdateSamlConfiguration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get list of identity providers for my account.
     * @return OK
     */
    accountSettings_GetIdentityProviders(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/identityProviders";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_GetIdentityProviders(_response);
        });
    }
    processAccountSettings_GetIdentityProviders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get my account's password policy.
     * @return OK
     */
    accountSettings_GetPasswordPolicy(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/passwordPolicy";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_GetPasswordPolicy(_response);
        });
    }
    processAccountSettings_GetPasswordPolicy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update password policy for my account.
     * @param body (optional) Password policy properties to update.
     * @return OK
     */
    accountSettings_UpdatePasswordPolicy(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount/passwordPolicy";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_UpdatePasswordPolicy(_response);
        });
    }
    processAccountSettings_UpdatePasswordPolicy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get my current account settings.
     * @return OK
     */
    accountSettings_GetMyAccountSettings(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_GetMyAccountSettings(_response);
        });
    }
    processAccountSettings_GetMyAccountSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update my current account settings.
     * @param body (optional)
     * @return OK
     */
    accountSettings_UpdateMyAccountSettings(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/myAccount";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAccountSettings_UpdateMyAccountSettings(_response);
        });
    }
    processAccountSettings_UpdateMyAccountSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves permissions defined in the system.
     * @return OK
     */
    permissions_GetPermissions(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/permissions";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPermissions_GetPermissions(_response);
        });
    }
    processPermissions_GetPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Send a push notification to all my push subscriptions.
     * @param body (optional)
     * @return No Content
     */
    pushSubscriptions_SendTestNotification(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/pushSubscriptions/send";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPushSubscriptions_SendTestNotification(_response);
        });
    }
    processPushSubscriptions_SendTestNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get VAPID public key.
     * @return OK
     */
    pushSubscriptions_GetVapidPublicKey(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/pushSubscriptions/vapid";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPushSubscriptions_GetVapidPublicKey(_response);
        });
    }
    processPushSubscriptions_GetVapidPublicKey(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Disable a push subscription for the current user.
     * @param endpoint The endpoint of the subscription to disable
     * @return OK
     */
    pushSubscriptions_DisablePushSubscription(endpoint, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/pushSubscriptions?";
        if (endpoint === undefined || endpoint === null)
            throw new Error("The parameter 'endpoint' must be defined and cannot be null.");
        else
            url_ += "endpoint=" + encodeURIComponent("" + endpoint) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPushSubscriptions_DisablePushSubscription(_response);
        });
    }
    processPushSubscriptions_DisablePushSubscription(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return OK
     */
    pushSubscriptions_GetPushSubscriptionByEndpoint(endpoint, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/pushSubscriptions?";
        if (endpoint === undefined || endpoint === null)
            throw new Error("The parameter 'endpoint' must be defined and cannot be null.");
        else
            url_ += "endpoint=" + encodeURIComponent("" + endpoint) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPushSubscriptions_GetPushSubscriptionByEndpoint(_response);
        });
    }
    processPushSubscriptions_GetPushSubscriptionByEndpoint(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new push subscription for the current user to receive push notifications using the provided subscription details.
     * @param body (optional) The subscription details to add.
     * @return Created
     */
    pushSubscriptions_CreatePushSubscription(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/pushSubscriptions";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPushSubscriptions_CreatePushSubscription(_response);
        });
    }
    processPushSubscriptions_CreatePushSubscription(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    login_ResendVerificationCode(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/resendCode";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogin_ResendVerificationCode(_response);
        });
    }
    processLogin_ResendVerificationCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get users assigned to the role with the specified id.
     * @param id The id of the role
     * @param userStatus (optional)
     * @param accountConfirmed (optional)
     * @param jobFunction (optional)
     * @param employeeKey (optional)
     * @param roleId (optional)
     * @param modifiedAfter (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    roles_GetUsersByRoleId(id, userStatus, accountConfirmed, jobFunction, employeeKey, roleId, modifiedAfter, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/roles/{id}/users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userStatus !== undefined && userStatus !== null)
            url_ += "userStatus=" + encodeURIComponent("" + userStatus) + "&";
        if (accountConfirmed !== undefined && accountConfirmed !== null)
            url_ += "accountConfirmed=" + encodeURIComponent("" + accountConfirmed) + "&";
        if (jobFunction !== undefined && jobFunction !== null)
            url_ += "jobFunction=" + encodeURIComponent("" + jobFunction) + "&";
        if (employeeKey !== undefined && employeeKey !== null)
            url_ += "employeeKey=" + encodeURIComponent("" + employeeKey) + "&";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (modifiedAfter !== undefined && modifiedAfter !== null)
            url_ += "modifiedAfter=" + encodeURIComponent("" + modifiedAfter) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRoles_GetUsersByRoleId(_response);
        });
    }
    processRoles_GetUsersByRoleId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get role by the specified id.
     * @param id The id of the role to retrieve.
     * @return OK
     */
    roles_GetRoleById(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRoles_GetRoleById(_response);
        });
    }
    processRoles_GetRoleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of roles using the specified search criteria.
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    roles_QueryRoles(page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/roles?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRoles_QueryRoles(_response);
        });
    }
    processRoles_QueryRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update notification status.
     * @param body (optional)
     * @return OK
     */
    notification_UpdateReadStatusById(notificationId, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/notifications/{notificationId}/readStatus";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processNotification_UpdateReadStatusById(_response);
        });
    }
    processNotification_UpdateReadStatusById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get notification by ID.
     */
    notification_GetNotificationById(notificationId, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processNotification_GetNotificationById(_response);
        });
    }
    processNotification_GetNotificationById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update notifications status by filter.
     * @param body (optional)
     * @return No Content
     */
    notification_UpdateReadStatusByFilter(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/notifications/readStatus";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processNotification_UpdateReadStatusByFilter(_response);
        });
    }
    processNotification_UpdateReadStatusByFilter(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get a summary of the notification counts.
     * @return OK
     */
    notification_GetNotificationsSummary(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/notifications/summary";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processNotification_GetNotificationsSummary(_response);
        });
    }
    processNotification_GetNotificationsSummary(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get all notifications.
     * @param actionTypes (optional)
     * @param isRead (optional)
     * @param before (optional)
     * @param after (optional)
     * @param perPage (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     */
    notification_QueryNotifications(actionTypes, isRead, before, after, perPage, page, includeTotals, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/notifications?";
        if (actionTypes !== undefined && actionTypes !== null)
            actionTypes && actionTypes.forEach(item => { url_ += "actionTypes=" + encodeURIComponent("" + item) + "&"; });
        if (isRead !== undefined && isRead !== null)
            url_ += "isRead=" + encodeURIComponent("" + isRead) + "&";
        if (before !== undefined && before !== null)
            url_ += "before=" + encodeURIComponent("" + before) + "&";
        if (after !== undefined && after !== null)
            url_ += "after=" + encodeURIComponent("" + after) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processNotification_QueryNotifications(_response);
        });
    }
    processNotification_QueryNotifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Change my password
     * @param body (optional) The user object to update.
     * @return No Content
     */
    password_ChangePassword(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/password/change";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPassword_ChangePassword(_response);
        });
    }
    processPassword_ChangePassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Change my password using password reset token
     * @param body (optional) The user object to update.
     * @return No Content
     */
    password_ResetPassword(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/password/reset";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPassword_ResetPassword(_response);
        });
    }
    processPassword_ResetPassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Sends an email to the user with a link to reset their password.
     * @param body (optional)
     * @return No Content
     */
    password_SendResetPasswordEmail(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/password/resetRequests";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processPassword_SendResetPasswordEmail(_response);
        });
    }
    processPassword_SendResetPasswordEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Activates user account using the token that was sent to the user in the welcome email.
     * @param body (optional) Activate account request object, which contains the token, password, firstName, and lastName.
     * @return No Content
     */
    profile_ActivateAccount(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/profile/activate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processProfile_ActivateAccount(_response);
        });
    }
    processProfile_ActivateAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get my profile info.
     * @return OK
     */
    profile_GetMyProfile(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/profile";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processProfile_GetMyProfile(_response);
        });
    }
    processProfile_GetMyProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update my profile information
     * @param body (optional) The user object to update.
     * @return OK
     */
    profile_UpdateMyProfile(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/self/profile";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processProfile_UpdateMyProfile(_response);
        });
    }
    processProfile_UpdateMyProfile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get team by the specified id.
     * @param id The id of the team to retrieve.
     * @return OK
     */
    teams_GetTeamById(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTeams_GetTeamById(_response);
        });
    }
    processTeams_GetTeamById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a new team according to the JSON object received in body.
     * @param id The id of the team to update.
     * @param body (optional) The definition of the team to create.
     * @return OK
     */
    teams_UpdateTeam(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTeams_UpdateTeam(_response);
        });
    }
    processTeams_UpdateTeam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of teams using the specified search criteria.
     * @param rootTeamId (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    teams_QueryTeams(rootTeamId, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/teams?";
        if (rootTeamId !== undefined && rootTeamId !== null)
            url_ += "rootTeamId=" + encodeURIComponent("" + rootTeamId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTeams_QueryTeams(_response);
        });
    }
    processTeams_QueryTeams(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new team according to the JSON object received in body.
     * @param body (optional) The definition of the team to create.
     * @return Created
     */
    teams_CreateTeam(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/teams";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processTeams_CreateTeam(_response);
        });
    }
    processTeams_CreateTeam(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates user email to the specified email.
     * @param id The id of the user to update.
     * @param body (optional) The new email address.
     * @return No Content
     */
    users_UpdateUserEmail(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/email";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_UpdateUserEmail(_response);
        });
    }
    processUsers_UpdateUserEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Sends (or re-sends) an invitation to the user to set a password and activate their account.
    Note, if the user account is already activated, the invite will not be resent.
     * @param id The id of the user to send welcome email to.
     * @return No Content
     */
    users_SendNewUserInvite(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/invites";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_SendNewUserInvite(_response);
        });
    }
    processUsers_SendNewUserInvite(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Sends a reset password email to the user.
     * @param id The id of the user to send a reset password email to.
     * @return No Content
     */
    users_SendResetPasswordEmail(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/resetPasswordRequests";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_SendResetPasswordEmail(_response);
        });
    }
    processUsers_SendResetPasswordEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get roles assigned to the user with the specified id.
     * @param id The id of the user.
     * @return OK
     */
    users_GetUserRoles(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_GetUserRoles(_response);
        });
    }
    processUsers_GetUserRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Assigns the specified roles to the user with the specified id.
     * @param id The id of the user to assign roles to.
     * @param body (optional) The list of roles to assign to the user.
     * @return OK
     */
    users_UpdateUserRoles(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_UpdateUserRoles(_response);
        });
    }
    processUsers_UpdateUserRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Changes user status to the specified status
     * @param id The id of the user to update.
     * @param body (optional) The status to set.
     * @return No Content
     */
    users_SetUserStatus(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_SetUserStatus(_response);
        });
    }
    processUsers_SetUserStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Unlocks user account if the user has been locked out due to too many failed login attempts.
     * @param id The id of the user to unlock.
     * @return No Content
     */
    users_UnlockUserAccount(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}/unlock";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_UnlockUserAccount(_response);
        });
    }
    processUsers_UnlockUserAccount(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get user by the specified id.
     * @param id The id of the user to retrieve.
     * @return OK
     */
    users_GetUserById(id, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_GetUserById(_response);
        });
    }
    processUsers_GetUserById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Partially updates a user with the object's properties received in the request's body. Note, only properties that are set on will be update.
     * @param id The id of the user to update.
     * @param body (optional) The user properties.
     * @return OK
     */
    users_PatchUser(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_PatchUser(_response);
        });
    }
    processUsers_PatchUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a user with the object's properties received in the request's body.
     * @param id The id of the user to update.
     * @param body (optional) The user object to update.
     * @return OK
     */
    users_UpdateUser(id, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_UpdateUser(_response);
        });
    }
    processUsers_UpdateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Export the current users to an Excel file
     * @return Excel file with the data of the users on account
     */
    users_ExportUsers(cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users/export";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_ExportUsers(_response);
        });
    }
    processUsers_ExportUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a list of users using the specified search criteria.
     * @param userStatus (optional)
     * @param accountConfirmed (optional)
     * @param jobFunction (optional)
     * @param employeeKey (optional)
     * @param roleId (optional)
     * @param modifiedAfter (optional)
     * @param page (optional)
     * @param includeTotals (optional)
     * @param orderDirection (optional)
     * @param orderField (optional)
     * @param perPage (optional)
     * @param searchText (optional)
     * @return OK
     */
    users_QueryUsers(userStatus, accountConfirmed, jobFunction, employeeKey, roleId, modifiedAfter, page, includeTotals, orderDirection, orderField, perPage, searchText, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users?";
        if (userStatus !== undefined && userStatus !== null)
            url_ += "userStatus=" + encodeURIComponent("" + userStatus) + "&";
        if (accountConfirmed !== undefined && accountConfirmed !== null)
            url_ += "accountConfirmed=" + encodeURIComponent("" + accountConfirmed) + "&";
        if (jobFunction !== undefined && jobFunction !== null)
            url_ += "jobFunction=" + encodeURIComponent("" + jobFunction) + "&";
        if (employeeKey !== undefined && employeeKey !== null)
            url_ += "employeeKey=" + encodeURIComponent("" + employeeKey) + "&";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (modifiedAfter !== undefined && modifiedAfter !== null)
            url_ += "modifiedAfter=" + encodeURIComponent("" + modifiedAfter) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (includeTotals === null)
            throw new Error("The parameter 'includeTotals' cannot be null.");
        else if (includeTotals !== undefined)
            url_ += "includeTotals=" + encodeURIComponent("" + includeTotals) + "&";
        if (orderDirection !== undefined && orderDirection !== null)
            url_ += "orderDirection=" + encodeURIComponent("" + orderDirection) + "&";
        if (orderField !== undefined && orderField !== null)
            url_ += "orderField=" + encodeURIComponent("" + orderField) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "perPage=" + encodeURIComponent("" + perPage) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_QueryUsers(_response);
        });
    }
    processUsers_QueryUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a new user according to the JSON object received in body.
     * @param sendInvite (optional) Indicates whether to send a welcome email to the user.
     * @param body (optional) The user object to create.
     * @return Created
     */
    users_CreateUser(sendInvite, body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/users?";
        if (sendInvite === null)
            throw new Error("The parameter 'sendInvite' cannot be null.");
        else if (sendInvite !== undefined)
            url_ += "sendInvite=" + encodeURIComponent("" + sendInvite) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUsers_CreateUser(_response);
        });
    }
    processUsers_CreateUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 422) {
            const _responseText = response.data;
            let result422 = null;
            let resultData422 = _responseText;
            result422 = JSON.parse(resultData422);
            return throwException("A request to modify or create a resource failed due to a validation error", status, _responseText, _headers, result422);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return OK
     */
    login_VerifyTwoFactorCode(body, cancelToken) {
        let url_ = this.baseUrl + "/id/api/v1/verifyCode";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogin_VerifyTwoFactorCode(_response);
        });
    }
    processLogin_VerifyTwoFactorCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
exports.Client = Client;
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["ACTIVE"] = "ACTIVE";
    AccountStatus["DISABLED"] = "DISABLED";
    AccountStatus["PENDING"] = "PENDING";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AccountType;
(function (AccountType) {
    AccountType["SELL_SIDE"] = "SELL_SIDE";
    AccountType["BUY_SIDE"] = "BUY_SIDE";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var ActionType;
(function (ActionType) {
    ActionType["GENERIC"] = "GENERIC";
    ActionType["NEW_IOI_ADDED"] = "NEW_IOI_ADDED";
    ActionType["NEW_REPORT_SHARED"] = "NEW_REPORT_SHARED";
    ActionType["NEW_OFFERING_NOTE_SHARED"] = "NEW_OFFERING_NOTE_SHARED";
    ActionType["FINAL_ALLOCATION_ENTERED"] = "FINAL_ALLOCATION_ENTERED";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var ConfigurationGroup;
(function (ConfigurationGroup) {
    ConfigurationGroup["CRM"] = "CRM";
    ConfigurationGroup["IDENTITY"] = "IDENTITY";
    ConfigurationGroup["WEB_APP"] = "WEB_APP";
    ConfigurationGroup["DATALAB"] = "DATALAB";
    ConfigurationGroup["ORDER_BOOK"] = "ORDER_BOOK";
})(ConfigurationGroup = exports.ConfigurationGroup || (exports.ConfigurationGroup = {}));
var ConfigurationGroupFilter;
(function (ConfigurationGroupFilter) {
    ConfigurationGroupFilter["CRM"] = "CRM";
    ConfigurationGroupFilter["IDENTITY"] = "IDENTITY";
    ConfigurationGroupFilter["WEB_APP"] = "WEB_APP";
    ConfigurationGroupFilter["DATALAB"] = "DATALAB";
    ConfigurationGroupFilter["ORDER_BOOK"] = "ORDER_BOOK";
})(ConfigurationGroupFilter = exports.ConfigurationGroupFilter || (exports.ConfigurationGroupFilter = {}));
var CrmLinkedStatus;
(function (CrmLinkedStatus) {
    CrmLinkedStatus["Not_Required"] = "Not Required";
    CrmLinkedStatus["Not_Configured"] = "Not Configured";
    CrmLinkedStatus["Configured"] = "Configured";
})(CrmLinkedStatus = exports.CrmLinkedStatus || (exports.CrmLinkedStatus = {}));
var DisabledReason;
(function (DisabledReason) {
    DisabledReason["UNSUBSCRIBED"] = "UNSUBSCRIBED";
    DisabledReason["REASSIGNED"] = "REASSIGNED";
    DisabledReason["EXPIRED_OR_UNAVAILABLE"] = "EXPIRED_OR_UNAVAILABLE";
    DisabledReason["ENDPOINT_INVALID"] = "ENDPOINT_INVALID";
    DisabledReason["USER_DISABLED"] = "USER_DISABLED";
    DisabledReason["TENANT_DISABLED"] = "TENANT_DISABLED";
})(DisabledReason = exports.DisabledReason || (exports.DisabledReason = {}));
var DraftAccountStatus;
(function (DraftAccountStatus) {
    DraftAccountStatus["Draft"] = "Draft";
    DraftAccountStatus["Initiated"] = "Initiated";
    DraftAccountStatus["Created"] = "Created";
    DraftAccountStatus["Duplicate"] = "Duplicate";
})(DraftAccountStatus = exports.DraftAccountStatus || (exports.DraftAccountStatus = {}));
var ExternalLicense;
(function (ExternalLicense) {
    ExternalLicense["CUSIP"] = "CUSIP";
})(ExternalLicense = exports.ExternalLicense || (exports.ExternalLicense = {}));
var GrantType;
(function (GrantType) {
    GrantType["IMPLICIT"] = "IMPLICIT";
    GrantType["AUTHORIZATION_CODE_WITH_PKCE"] = "AUTHORIZATION_CODE_WITH_PKCE";
})(GrantType = exports.GrantType || (exports.GrantType = {}));
var IdentityProviderType;
(function (IdentityProviderType) {
    IdentityProviderType["AzureAdOpenId"] = "AzureAdOpenId";
    IdentityProviderType["Saml2P"] = "Saml2P";
    IdentityProviderType["OpenIdConnect"] = "OpenIdConnect";
    IdentityProviderType["WsFederation"] = "WsFederation";
})(IdentityProviderType = exports.IdentityProviderType || (exports.IdentityProviderType = {}));
/** JobFunction indicates user's function within an organization. Note, values without [ValidFor] attribute indicates the value is valid for both accounts (buy-side and sell-side). * Buy-Side Only Job Functions: ANALYST, PORTFOLIO_MANAGER, TRADER * Sell-Side Only Job Functions:  ECM, ECM_SURVEILLANCE, SALES, SALES_SUPERVISOR, SALES_TRADER, SALES_TRADER_SUPERVISOR, SYNDICATE_OPERATIONS, SYNDICATE_ACCOUNTING, PRODUCT_CONTROL * Job Functions for Both: ADMINISTRATOR, ASSISTANT, LEGAL_COMPLIANCE, OTHER, SUPPORT, SYNDICATE, TECHNOLOGY */
var JobFunction;
(function (JobFunction) {
    JobFunction["ANALYST"] = "ANALYST";
    JobFunction["PORTFOLIO_MANAGER"] = "PORTFOLIO_MANAGER";
    JobFunction["TRADER"] = "TRADER";
    JobFunction["SYNDICATE"] = "SYNDICATE";
    JobFunction["ADMINISTRATOR"] = "ADMINISTRATOR";
    JobFunction["LEGAL_COMPLIANCE"] = "LEGAL_COMPLIANCE";
    JobFunction["TECHNOLOGY"] = "TECHNOLOGY";
    JobFunction["ASSISTANT"] = "ASSISTANT";
    JobFunction["SUPPORT"] = "SUPPORT";
    JobFunction["ECM"] = "ECM";
    JobFunction["SALES"] = "SALES";
    JobFunction["SALES_SUPERVISOR"] = "SALES_SUPERVISOR";
    JobFunction["SALES_TRADER"] = "SALES_TRADER";
    JobFunction["SALES_TRADER_SUPERVISOR"] = "SALES_TRADER_SUPERVISOR";
    JobFunction["OTHER"] = "OTHER";
    JobFunction["ECM_SURVEILLANCE"] = "ECM_SURVEILLANCE";
    JobFunction["SYNDICATE_OPERATIONS"] = "SYNDICATE_OPERATIONS";
    JobFunction["SYNDICATE_ACCOUNTING"] = "SYNDICATE_ACCOUNTING";
    JobFunction["PRODUCT_CONTROL"] = "PRODUCT_CONTROL";
})(JobFunction = exports.JobFunction || (exports.JobFunction = {}));
var KeyRemapReason;
(function (KeyRemapReason) {
    KeyRemapReason["MAPPING_CORRECTION"] = "MAPPING_CORRECTION";
    KeyRemapReason["CORP_STRUCTURE_CHANGE"] = "CORP_STRUCTURE_CHANGE";
})(KeyRemapReason = exports.KeyRemapReason || (exports.KeyRemapReason = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["TRIAL"] = "TRIAL";
    LicenseType["PAID"] = "PAID";
})(LicenseType = exports.LicenseType || (exports.LicenseType = {}));
var LoginResultCode;
(function (LoginResultCode) {
    LoginResultCode["SUCCESS"] = "SUCCESS";
    LoginResultCode["REQUIRE_TWO_FACTOR"] = "REQUIRE_TWO_FACTOR";
    LoginResultCode["PASSWORD_EXPIRED"] = "PASSWORD_EXPIRED";
    LoginResultCode["LOCKED_OUT"] = "LOCKED_OUT";
    LoginResultCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    LoginResultCode["USER_INACTIVE"] = "USER_INACTIVE";
    LoginResultCode["ACCOUNT_DISABLED"] = "ACCOUNT_DISABLED";
    LoginResultCode["TRIAL_EXPIRED"] = "TRIAL_EXPIRED";
    LoginResultCode["NOT_ALLOWED"] = "NOT_ALLOWED";
    LoginResultCode["INVALID_VERIFICATION_CODE"] = "INVALID_VERIFICATION_CODE";
})(LoginResultCode = exports.LoginResultCode || (exports.LoginResultCode = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["OFFERING"] = "OFFERING";
    ResourceType["IOI"] = "IOI";
    ResourceType["SHARED_REPORT"] = "SHARED_REPORT";
    ResourceType["ALLOCATION"] = "ALLOCATION";
    ResourceType["OFFERING_NOTE"] = "OFFERING_NOTE";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var ServiceErrorCode;
(function (ServiceErrorCode) {
    ServiceErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ServiceErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ServiceErrorCode["EDIT_CONFLICT"] = "EDIT_CONFLICT";
    ServiceErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    ServiceErrorCode["LOCKED_OUT"] = "LOCKED_OUT";
    ServiceErrorCode["PASSWORD_EXPIRED"] = "PASSWORD_EXPIRED";
    ServiceErrorCode["DUPLICATE"] = "DUPLICATE";
    ServiceErrorCode["IP_BLOCKED"] = "IP_BLOCKED";
    ServiceErrorCode["UNHANDLED_ERROR"] = "UNHANDLED_ERROR";
    ServiceErrorCode["NETWORK_FAILURE"] = "NETWORK_FAILURE";
    ServiceErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ServiceErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
})(ServiceErrorCode = exports.ServiceErrorCode || (exports.ServiceErrorCode = {}));
var SortOrderDirection;
(function (SortOrderDirection) {
    SortOrderDirection["ASC"] = "ASC";
    SortOrderDirection["DESC"] = "DESC";
})(SortOrderDirection = exports.SortOrderDirection || (exports.SortOrderDirection = {}));
var TraitCode;
(function (TraitCode) {
    TraitCode["MY_DATA_LAB"] = "MY_DATA_LAB";
    TraitCode["API_KEYS"] = "API_KEYS";
    TraitCode["DATALAB_REPORTS"] = "DATALAB_REPORTS";
    TraitCode["DATALAB_API"] = "DATALAB_API";
    TraitCode["XC_CALENDAR"] = "XC_CALENDAR";
    TraitCode["XC_INDICATE"] = "XC_INDICATE";
    TraitCode["XC_CREATE"] = "XC_CREATE";
    TraitCode["MY_SECTORS"] = "MY_SECTORS";
    TraitCode["DATALAB_UI_LIVE_FILED"] = "DATALAB_UI_LIVE_FILED";
    TraitCode["INTERNATIONAL"] = "INTERNATIONAL";
    TraitCode["CONVERTS"] = "CONVERTS";
    TraitCode["ATM"] = "ATM";
    TraitCode["ATM_SELLDOWN"] = "ATM_SELLDOWN";
    TraitCode["XC_TEST_OFFERINGS_IN_CALENDAR"] = "XC_TEST_OFFERINGS_IN_CALENDAR";
    TraitCode["XC_OFF_PLATFORM_OFFERINGS"] = "XC_OFF_PLATFORM_OFFERINGS";
    TraitCode["XC_IOI_NOTES"] = "XC_IOI_NOTES";
    TraitCode["CERTIFICATE_LIBRARY"] = "CERTIFICATE_LIBRARY";
    TraitCode["CERTIFICATE_REVIEW"] = "CERTIFICATE_REVIEW";
    TraitCode["XC_CREATE_INTERNATIONAL"] = "XC_CREATE_INTERNATIONAL";
    TraitCode["INTERNATIONAL_OFFERING_TYPES"] = "INTERNATIONAL_OFFERING_TYPES";
    TraitCode["DL_EXCEL_DOWNLOAD"] = "DL_EXCEL_DOWNLOAD";
    TraitCode["DATALAB_API_SUBSCRIPTIONS"] = "DATALAB_API_SUBSCRIPTIONS";
    TraitCode["DATALAB_EXCEL_ADDIN"] = "DATALAB_EXCEL_ADDIN";
    TraitCode["DATALAB_CALENDAR"] = "DATALAB_CALENDAR";
    TraitCode["DEMAND_COMMUNICATION_API"] = "DEMAND_COMMUNICATION_API";
    TraitCode["DEMAND_ANALYTICS"] = "DEMAND_ANALYTICS";
    TraitCode["INTERNAL_OFFERINGS"] = "INTERNAL_OFFERINGS";
    TraitCode["PREMIUM_AI"] = "PREMIUM_AI";
    TraitCode["DATALAB_MOBILE_APP"] = "DATALAB_MOBILE_APP";
})(TraitCode = exports.TraitCode || (exports.TraitCode = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["DISABLED"] = "DISABLED";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var OrderField;
(function (OrderField) {
    OrderField["Name"] = "name";
})(OrderField = exports.OrderField || (exports.OrderField = {}));
var OrderField2;
(function (OrderField2) {
    OrderField2["ConfigurationGroup"] = "configurationGroup";
    OrderField2["Key"] = "key";
})(OrderField2 = exports.OrderField2 || (exports.OrderField2 = {}));
var OrderField3;
(function (OrderField3) {
    OrderField3["FirstName"] = "firstName";
    OrderField3["LastName"] = "lastName";
    OrderField3["Email"] = "email";
    OrderField3["LastLoginTime"] = "lastLoginTime";
    OrderField3["LastIpAddress"] = "lastIpAddress";
    OrderField3["Status"] = "status";
    OrderField3["LockoutEnd"] = "lockoutEnd";
    OrderField3["EmployeeKey"] = "employeeKey";
})(OrderField3 = exports.OrderField3 || (exports.OrderField3 = {}));
var OrderField4;
(function (OrderField4) {
    OrderField4["Name"] = "name";
})(OrderField4 = exports.OrderField4 || (exports.OrderField4 = {}));
var OrderField5;
(function (OrderField5) {
    OrderField5["FirstName"] = "firstName";
    OrderField5["LastName"] = "lastName";
    OrderField5["Email"] = "email";
    OrderField5["LastLoginTime"] = "lastLoginTime";
    OrderField5["LastIpAddress"] = "lastIpAddress";
    OrderField5["Status"] = "status";
    OrderField5["LockoutEnd"] = "lockoutEnd";
    OrderField5["EmployeeKey"] = "employeeKey";
})(OrderField5 = exports.OrderField5 || (exports.OrderField5 = {}));
var OrderField6;
(function (OrderField6) {
    OrderField6["Name"] = "name";
    OrderField6["Subdomain"] = "subdomain";
    OrderField6["CmgEntityKey"] = "cmgEntityKey";
    OrderField6["DatabaseName"] = "databaseName";
    OrderField6["DatabaseHost"] = "databaseHost";
    OrderField6["AccountType"] = "accountType";
    OrderField6["Status"] = "status";
    OrderField6["LicenseType"] = "licenseType";
    OrderField6["LicenseCount"] = "licenseCount";
})(OrderField6 = exports.OrderField6 || (exports.OrderField6 = {}));
var OrderField7;
(function (OrderField7) {
    OrderField7["ConfigurationGroup"] = "configurationGroup";
    OrderField7["Key"] = "key";
})(OrderField7 = exports.OrderField7 || (exports.OrderField7 = {}));
var OrderField8;
(function (OrderField8) {
    OrderField8["BankAccountSubdomain"] = "bankAccountSubdomain";
    OrderField8["CrmInvestorFirmName"] = "crmInvestorFirmName";
    OrderField8["CrmInvestorSuggestedSubdomain"] = "crmInvestorSuggestedSubdomain";
    OrderField8["EntityMasterInvestorName"] = "entityMasterInvestorName";
    OrderField8["InvestorCmgEntityKey"] = "investorCmgEntityKey";
    OrderField8["InvestorSubdomain"] = "investorSubdomain";
    OrderField8["Status"] = "status";
})(OrderField8 = exports.OrderField8 || (exports.OrderField8 = {}));
var OrderField9;
(function (OrderField9) {
    OrderField9["Name"] = "name";
})(OrderField9 = exports.OrderField9 || (exports.OrderField9 = {}));
var OrderField10;
(function (OrderField10) {
    OrderField10["FirstName"] = "firstName";
    OrderField10["LastName"] = "lastName";
    OrderField10["Email"] = "email";
    OrderField10["LastLoginTime"] = "lastLoginTime";
    OrderField10["LastIpAddress"] = "lastIpAddress";
    OrderField10["Status"] = "status";
    OrderField10["LockoutEnd"] = "lockoutEnd";
    OrderField10["EmployeeKey"] = "employeeKey";
})(OrderField10 = exports.OrderField10 || (exports.OrderField10 = {}));
var OrderField11;
(function (OrderField11) {
    OrderField11["Name"] = "name";
})(OrderField11 = exports.OrderField11 || (exports.OrderField11 = {}));
var OrderField12;
(function (OrderField12) {
    OrderField12["Name"] = "name";
})(OrderField12 = exports.OrderField12 || (exports.OrderField12 = {}));
var OrderField13;
(function (OrderField13) {
    OrderField13["FirstName"] = "firstName";
    OrderField13["LastName"] = "lastName";
    OrderField13["Email"] = "email";
    OrderField13["LastLoginTime"] = "lastLoginTime";
    OrderField13["LastIpAddress"] = "lastIpAddress";
    OrderField13["Status"] = "status";
    OrderField13["LockoutEnd"] = "lockoutEnd";
    OrderField13["EmployeeKey"] = "employeeKey";
})(OrderField13 = exports.OrderField13 || (exports.OrderField13 = {}));
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
